import { gql, MutationTuple, useMutation } from '@apollo/client';

export const UPSERT_COLLECTION_COURSE = gql`
  mutation UpsertCollectionCourse(
    $courseId: NonEmptyString!
    $providerId: NonEmptyString!
    $collectionId: String
    $skillId: NonEmptyString
  ) {
    upsertCollectionCourse(
      courseId: $courseId
      providerId: $providerId
      collectionId: $collectionId
      skillId: $skillId
    ) {
      collection {
        id
        name
        studentId
        courseCount
      }
      collectionId
      course {
        id
        name
        provider
        url
        imageUrl
        logoUrl
        hasMagicLink
        magicLink
      }
      courseId
      id
      providerId
      skill {
        id
        name
        type
        status
        translatedType
      }
      skillId
    }
  }
`;

export interface IUpsertCollectionCourseParams {
  courseId: string;
  providerId: string;
  collectionId?: string;
  skillId?: string;
}

export interface ICollection {
  id: string;
  name: string;
  studentId: string;
  courseCount: number;
}

export interface ICourse {
  id: string;
  name: string;
  provider: string;
  url: string;
  imageUrl: string;
  logoUrl: string;
  hasMagicLink: boolean;
  magicLink: string;
}

export interface ISkill {
  id: string;
  name: string;
  type: string;
  status: string;
  translatedType: string;
}

export interface IStudentCourseSaved {
  collection: ICollection;
  collectionId: string;
  course: ICourse;
  courseId: string;
  id: string;
  providerId: string;
  skill: ISkill;
  skillId: string;
}

export interface IUpsertCollectionCourseResponse {
  upsertCollectionCourse: IStudentCourseSaved;
}

export const useMutationUpsertCollectionCourse = (): MutationTuple<
  IUpsertCollectionCourseResponse,
  IUpsertCollectionCourseParams
> => useMutation<IUpsertCollectionCourseResponse, IUpsertCollectionCourseParams>(UPSERT_COLLECTION_COURSE);
